

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
// import "../../pages/css/SupplierPromotionList.css";
import { useTranslation } from "react-i18next";

const API = "https://api.mahal.qa/api/v1";

const SupplierPromotionList = () => {

  const [promotions, setPromotions] = useState([]);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    fetchPromotions();
  }, [i18n.language]); // ✅ important for language refresh

  const fetchPromotions = async () => {
    try {
      const res = await axios.get(
        `${API}/supplier/promotions?lang=${i18n.language}`, // ✅ pass lang
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setPromotions(res.data);

    } catch (err) {
      console.log(err);
    }
  };

  const isArabic = i18n.language?.startsWith("ar");

const formatNumber = (num) => {
  return new Intl.NumberFormat(
    isArabic ? "ar-EG" : "en-US"
  ).format(num);
};

const formatCurrency = (num) => {
  const value = formatNumber(Number(num || 0));
  return isArabic ? `ر.ق ${value}` : `QAR ${value}`;
};

const formatDate = (date) => {
  if (!date) return "-";

  return new Intl.DateTimeFormat(
    isArabic ? "ar-EG" : "en-GB",
    {
      year: "numeric",
      month: "short",
      day: "numeric",
    }
  ).format(new Date(date));
};

  return (
    <div className="promo-list-page">

      <h2>{t("promotion_review")}</h2>

      <table className="promo-table">

        <thead>
          <tr>
            <th>{t("id")}</th>
            <th>{t("title")}</th>
            <th>{t("offer")}</th>
            <th>{t("start_date")}</th>
            <th>{t("end_date")}</th>
            <th>{t("status")}</th>
            <th>{t("action")}</th>
          </tr>
        </thead>

        <tbody>

          {promotions.length === 0 && (
            <tr>
              <td colSpan="7" style={{ textAlign:"center" }}>
                {t("no_promotions")}
              </td>
            </tr>
          )}

          {promotions.map((promo) => (
            <tr key={promo.promo_id}>

              <td>{formatNumber(promo.promo_id)}</td>

              {/* ✅ TITLE LANGUAGE SWITCH */}
              <td>
                {i18n.language === "ar"
                  ? promo.title_arabic || promo.title
                  : promo.title}
              </td>

              <td>
                {promo.offer_type === "PERCENTAGE"
                  ? `${formatNumber(promo.offer_value)}% ${t("off")}`
                  : `${formatCurrency(promo.offer_value)} ${t("off")}`}
              </td>

              <td>{formatDate(promo.start_date)}</td>

              <td>{formatDate(promo.end_date)}</td>

              <td>
                <span className={`status ${promo.supplier_status}`}>
                  {t(`status_${promo.supplier_status?.toLowerCase()}`) || promo.supplier_status}
                </span>
              </td>

              <td>
                <button
                  className="view-btn"
                  onClick={() =>
                    navigate(`/dashboard/promotion-review/${promo.promo_id}`)
                  }
                >
                  {t("view")}
                </button>
              </td>

            </tr>
          ))}

        </tbody>

      </table>

    </div>
  );
};

export default SupplierPromotionList;